export default __webpack_public_path__ + "static/media/Broadcasting.51fd2e49.png";